

import React from 'react'
import "../../styles/about.css";

const About = () => {
    return <section id="about">
       <div className="container">
        <div className="about_wrapper">
            <div className="about_content"> 
            <h2 className="ps">About
                    <span className="highlight"> Us</span>
                </h2>
                
            
            <p className="description_about_content-desc">
                At Brandstorm Marketing, we incorporate such values as reliability 
                and exceptional skillset, among a plethora of others,
                 to give your product or service the stellar publicity it deserves.
                </p>


                <h2 className="ps">What
                    <span className="highlight"> we have to offer</span>
                </h2>
                <p className="description_about_content-desc">
                For starters, we help you build your brand by ensuring that it gradually gains 
                presence on social media, in a quest for your product or service to be recognized by potential customers. We develop all necessary 
                advertising materials and help you reach your target.
                </p>
            </div>

    


            <div className="about_img">
                <img src="" alt="" />
            </div>
        </div>
        </div> 
    </section> 
};

export default About